import { getBytes, listAll, ref, uploadString } from 'firebase/storage'
import { storage } from './firebaseClient'

const LOGS_FOLDER = 'Logs'
const TEXT_DECODER = new TextDecoder('utf-8')

function padMonth(value) {
  return String(value).padStart(2, '0')
}

function currentIsoDate() {
  return new Date().toISOString()
}

function createLogId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

function normalizeLogList(value) {
  return Array.isArray(value) ? value.filter(item => item && typeof item === 'object') : []
}

function monthIdForDate(date = new Date()) {
  const normalizedDate = date instanceof Date ? date : new Date(date)
  return `${normalizedDate.getFullYear()}-${padMonth(normalizedDate.getMonth() + 1)}`
}

function monthIdFromFilename(filename) {
  const match = String(filename || '').match(/(\d{4})-(\d{2})/)
  return match ? `${match[1]}-${match[2]}` : monthIdForDate()
}

function isMissingStorageObject(error) {
  return error && (
    error.code === 'storage/object-not-found' ||
    String(error.message || '').includes('Object does not exist')
  )
}

function logStoragePath(filename) {
  return `${LOGS_FOLDER}/${filename}`
}

export function logFileNameForMonth(monthId) {
  return `logs-${monthId}.json`
}

export function logFileNameForDate(date = new Date()) {
  return logFileNameForMonth(monthIdForDate(date))
}

export function logMonthLabel(filename) {
  const monthId = monthIdFromFilename(filename)
  const [year, month] = monthId.split('-').map(Number)
  const date = new Date(year, month - 1, 1)

  return date.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'long'
  })
}

export async function fetchLogFile(filename = logFileNameForDate()) {
  try {
    const bytes = await getBytes(ref(storage, logStoragePath(filename)))
    const text = TEXT_DECODER.decode(bytes)
    return normalizeLogList(JSON.parse(text))
  } catch (error) {
    if (isMissingStorageObject(error)) return []
    throw error
  }
}

export async function fetchLogFiles() {
  try {
    const result = await listAll(ref(storage, LOGS_FOLDER))
    return result.items
      .map(item => item.name)
      .filter(name => /\.json$/i.test(name))
      .sort((a, b) => b.localeCompare(a))
  } catch (error) {
    if (isMissingStorageObject(error)) return []
    throw error
  }
}

export async function appendActionLog(payload = {}) {
  const timestamp = currentIsoDate()
  const filename = logFileNameForDate(timestamp)
  const storageRef = ref(storage, logStoragePath(filename))
  const logs = await fetchLogFile(filename)
  const entry = {
    id: createLogId(),
    timestamp,
    action: payload.action || 'unknown',
    entityType: payload.entityType || '',
    entityId: payload.entityId || '',
    title: payload.title || '',
    actor: payload.actor || null,
    route: payload.route || '',
    details: payload.details || {}
  }

  logs.push(entry)

  await uploadString(
    storageRef,
    JSON.stringify(logs, null, 2),
    'raw',
    { contentType: 'application/json;charset=utf-8' }
  )

  return entry
}
